<template>
    <div class="sidebar">
        <el-menu active-text-color="#fff" text-color="#fff" background-color="transparent" class="sidebar-menu"
                 :default-active="$route.path.split('/').length>2?('/'+$route.path.split('/')[1]):$route.path"
                 :default-openeds="SideOpen"
                 :collapse="isCollapse"
                 unique-opened router>

            <el-menu-item index="/account" class="accountMenuItem">
                <div class="sidebar-user">
                    <div class="sidebar-avatar">
                        <img v-if="getCompanyLogoUrlByCompany(selectedCompany) !== '' && !isCompanyLogoFailed(selectedCompany)"
                             class="sidebar-avatar-image"
                             :class="{'is-visible': isCompanyLogoLoaded(selectedCompany)}"
                             :src="getCompanyLogoUrlByCompany(selectedCompany)"
                             alt=""
                             @load="markCompanyLogoLoaded(selectedCompany)"
                             @error="markCompanyLogoFailed(selectedCompany)">
                        <span v-if="getCompanyLogoUrlByCompany(selectedCompany) === '' || isCompanyLogoFailed(selectedCompany) || !isCompanyLogoLoaded(selectedCompany)">
                            {{getCompanyInitial(selectedCompany)}}
                        </span>
                    </div>
                    <div class="sidebar-user-content">
                        <div class="sidebar-user-name">{{selectedCompany ? selectedCompany.companyName : ''}}</div>
                        <div class="sidebar-user-email">{{loginEmail}}</div>
                    </div>
                    <div class="companyDropdownWrapper" @click.stop>
                        <el-dropdown trigger="click"
                                     class="companyDropdown"
                                     popper-class="company-dropdown-popper"
                                     @visible-change="handleCompanyDropdownVisible"
                                     @command="handleCompanyCommand">
                            <button type="button" class="companyArrowButton">
                                <i class="el-icon-arrow-down companyArrow"></i>
                            </button>
                            <el-dropdown-menu slot="dropdown" class="companyDropdownMenu">
                                <el-dropdown-item
                                        v-for="company in dropdownCompanyList"
                                        :key="company.innerUUID"
                                        :command="company.innerUUID"
                                    class="companyDropdownItem">
                                    <div class="companyOption">
                                        <div class="companyOptionLogo" v-if="getCompanyLogoUrlByCompany(company) !== '' && !isCompanyLogoFailed(company)">
                                            <img class="companyOptionLogoImage"
                                                 :style="{
                                                     maxWidth: '100px',
                                                     maxHeight: '50px',
                                                     width: 'auto',
                                                     height: 'auto',
                                                     objectFit: 'contain',
                                                     display: isCompanyLogoLoaded(company) ? 'block' : 'none'
                                                 }"
                                                 :src="getCompanyLogoUrlByCompany(company)"
                                                 alt=""
                                                 @load="markCompanyLogoLoaded(company)"
                                                 @error="markCompanyLogoFailed(company)">
                                        </div>
                                        <span class="companyOptionName">{{company.companyName}}</span>
                                    </div>
                                </el-dropdown-item>
                                <el-dropdown-item divided :command="addBusinessCommand" class="companyDropdownItem addBusinessItem">
                                    <div class="addBusinessOption">
                                        <i class="el-icon-plus"></i>
                                        <span>{{$t('menu.addBusiness')}}</span>
                                    </div>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
            </el-menu-item>

            <el-menu-item index="/invoice">
                <i class="el-icon-s-home sidebar-menu-icon"></i>
                <span class="menuValue">{{$t('menu.invoices')}}</span>
            </el-menu-item>

            <el-menu-item index="/estimate">
                <i class="el-icon-date sidebar-menu-icon"></i>
                <span class="menuValue">{{$t('menu.estimates')}}</span>
            </el-menu-item>

            <el-menu-item index="/purchaseOrder">
                <i class="el-icon-tickets sidebar-menu-icon"></i>
                <span class="menuValue">{{$t('menu.purchaseOrders')}}</span>
            </el-menu-item>

            <el-menu-item index="/item">
                <i class="el-icon-shopping-bag-2 sidebar-menu-icon"></i>
                <span class="menuValue">{{$t('menu.items')}}</span>
            </el-menu-item>
            <el-menu-item index="/client">
                <i class="el-icon-user sidebar-menu-icon"></i>
                <span class="menuValue">{{$t('menu.clients')}}</span>
            </el-menu-item>

            <el-menu-item index="/expense">
                <i class="el-icon-coin sidebar-menu-icon"></i>
                <span class="menuValue">{{$t('menu.expenses')}}</span>
            </el-menu-item>

            <el-menu-item v-if="showReportMenu" index="/report">
                <i class="el-icon-data-analysis sidebar-menu-icon"></i>
                <span class="menuValue">{{$t('menu.reports')}}</span>
            </el-menu-item>


            <el-submenu index="/setting">
                <template slot="title">
                    <i class="el-icon-setting sidebar-menu-icon"></i>
                    <span class="menuValue">{{$t('menu.settings')}}</span>
                </template>
                <el-menu-item-group class="subMenuValue">
                    <el-menu-item index="/company_info" class="sidebar-submenu-child">
                        <i class="el-icon-office-building sidebar-submenu-icon"></i>
                        <span>{{$t('menu.companyInfo')}}</span>
                    </el-menu-item>
                    <el-menu-item index="/setting" class="sidebar-submenu-child">
                        <i class="el-icon-document sidebar-submenu-icon"></i>
                        <span>{{$t('menu.taxes')}}</span>
                    </el-menu-item>
                    <el-menu-item index="/default" class="sidebar-submenu-child">
                        <i class="el-icon-s-operation sidebar-submenu-icon"></i>
                        <span>{{$t('menu.default')}}</span>
                    </el-menu-item>
                    <el-menu-item index="/invoice-design" class="sidebar-submenu-child">
                        <i class="el-icon-edit-outline sidebar-submenu-icon"></i>
                        <span>{{$t('menu.customizeInvoice')}}</span>
                    </el-menu-item>
                </el-menu-item-group>
            </el-submenu>

            <el-menu-item index="/feedback">
                <i class="el-icon-message sidebar-menu-icon"></i>
                <span class="menuValue">{{$t('menu.sendFeedback')}}</span>
                <span v-if="loginEmail === 'dg@hazkargo.com'" class="feedback-reply-badge">{{$t('menu.newReply')}}</span>
            </el-menu-item>


        </el-menu>
        <div class="sidebar-lang-switcher">
            <el-dropdown trigger="click" @command="switchLang" placement="top">
                <span class="sidebar-lang-trigger">
                    <i class="el-icon-s-operation"></i>
                    <span class="sidebar-lang-current">{{currentLangLabel}}</span>
                    <i class="el-icon-arrow-up sidebar-lang-caret"></i>
                </span>
                <el-dropdown-menu slot="dropdown" class="sidebar-lang-menu">
                    <el-dropdown-item v-for="lang in langList"
                                      :key="lang.code"
                                      :command="lang.code"
                                      :class="{'is-active': $i18n.locale === lang.code}">
                        {{lang.label}}
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
        <button type="button" class="signOutButton" @click="loginOutDialog = true">
            <i class="el-icon-right"></i>
            <span>{{$t('menu.signOut')}}</span>
        </button>
        <el-dialog
                :title="$t('menu.signOut')"
                :visible.sync="loginOutDialog"
                width="30%">
            <span>{{$t('menu.signOutConfirm')}}</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="loginOutDialog = false">{{$t('common.cancel')}}</el-button>
                <el-button type="primary" :disabled="buttonDisabledStatus" :loading="loading" @click="loginOut()">{{$t('menu.signOut')}}</el-button>
              </span>
        </el-dialog>
        <el-dialog
                :title="$t('menu.newBusinessTitle')"
                :visible.sync="createCompanyDialog"
                :close-on-click-modal="!createCompanyLoading"
                :close-on-press-escape="!createCompanyLoading"
                append-to-body
                width="480px"
                custom-class="create-company-dialog">
            <el-form @submit.native.prevent="createCompany">
                <el-form-item :label="$t('menu.businessName')">
                    <el-input
                            ref="companyNameInput"
                            v-model="newCompanyName"
                            :maxlength="1000"
                            :placeholder="$t('menu.businessNamePlaceholder')"
                            @keyup.enter.native="createCompany">
                    </el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button :disabled="createCompanyLoading" @click="createCompanyDialog = false">{{$t('common.cancel')}}</el-button>
                <el-button type="primary" :loading="createCompanyLoading" @click="createCompany">{{$t('menu.createBusiness')}}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {
        applyCompanySelectionByIndex,
        applyCompanySelectionByUUID,
        getCurrentCompany,
        getSelectedCompanyIndex,
        getStoredCompanyList,
        syncCompanySelection
    } from '@/utils/company'
    import {getDownloadV2Url} from '@/utils/fileUpload'
    import {uuid} from '@/utils/validate'
    import {
        canCreateNewCompany,
        getActiveCompanyList,
        getCurrentPlanName,
        openFastSpringPage
    } from '@/utils/subscription'

    const LANG_LIST = [
        {code: 'en', label: 'English'},
        {code: 'zh', label: '中文'},
        {code: 'fr', label: 'Français'},
        {code: 'de', label: 'Deutsch'},
        {code: 'es', label: 'Español'},
        {code: 'ja', label: '日本語'},
        {code: 'ms', label: 'Bahasa Melayu'},
        {code: 'id', label: 'Bahasa Indonesia'},
        {code: 'tl', label: 'Filipino'}
    ];

    export default {
        name: "leftMenu",
        data() {
            return {
                SideOpen: ["setting"],
                loginOutDialog: false,
                isCollapse: false,
                pt: '',
                loginEmail: "",
                buttonDisabledStatus: false,
                loading: false,
                companyList: [],
                selectedCompany: null,
                companyLogoMap: {},
                companyLogoMapLoaded: false,
                failedLogoCompanyUUIDMap: {},
                loadedLogoCompanyUUIDMap: {},
                switchCompanyLoading: false,
                showReportMenu: true,
                addBusinessCommand: '__add_business__',
                createCompanyDialog: false,
                createCompanyLoading: false,
                newCompanyName: '',
                langList: LANG_LIST
            }
        },
        computed: {
            currentLangLabel() {
                const found = LANG_LIST.find(l => l.code === this.$i18n.locale);
                return found ? found.label : 'English';
            },
            dropdownCompanyList() {
                let list = this.companyList && this.companyList.length > 0
                    ? getActiveCompanyList(this.companyList)
                    : [];
                const current = this.selectedCompany != null ? this.selectedCompany : getCurrentCompany();
                if (current != null && (current.syncStatus === 0 || current.syncStatus === 2)) {
                    const exists = list.some(item => item.innerUUID === current.innerUUID);
                    if (!exists) {
                        list.unshift(current);
                    }
                }
                return list;
            }
        },
        methods: {
            switchLang(lang) {
                if (this.$i18n.locale === lang) {
                    return;
                }
                this.$i18n.locale = lang;
            },
            loginOut() {
                let that = this;
                this.loading = true;
                this.buttonDisabledStatus = true;
                this.$axios.post('login_out', {
                    params: {}
                }).then(() => {
                    localStorage.clear();
                    that.$router.push('/login');
                    this.buttonDisabledStatus = false;
                    this.loading = false;
                }).catch(function () {
                    that.buttonDisabledStatus = false;
                    that.loading = false;
                })
            },
            loadCompanyListFromStorage() {
                this.companyList = getStoredCompanyList();
                const selectedCompanyIndex = getSelectedCompanyIndex();
                if (selectedCompanyIndex >= 0 && selectedCompanyIndex < this.companyList.length) {
                    this.selectedCompany = this.companyList[selectedCompanyIndex];
                    return;
                }
                this.selectedCompany = null;
            },
            loadCompanyListIfNeeded() {
                this.loadCompanyListFromStorage();
                if (this.companyList.length > 0 && this.companyLogoMapLoaded) {
                    return;
                }
                this.switchCompanyLoading = true;
                let that = this;
                this.$axios.post('query_setting_and_company', {
                    params: {}
                }).then(response => {
                    if (response.data.errorCode === 0) {
                        let selectedData = syncCompanySelection(response.data);
                        that.companyLogoMap = response.data.companyLogoMap;
                        that.companyLogoMapLoaded = true;
                        that.failedLogoCompanyUUIDMap = {};
                        that.loadedLogoCompanyUUIDMap = {};
                        that.companyList = getStoredCompanyList();
                        if (selectedData != null) {
                            that.selectedCompany = that.companyList[selectedData.index];
                        }
                    }
                    that.switchCompanyLoading = false;
                }).catch(function () {
                    that.switchCompanyLoading = false;
                })
            },
            handleCompanyDropdownVisible(visible) {
                if (visible) {
                    this.loadCompanyListIfNeeded();
                }
            },
            handleCompanyCommand(companyUUID) {
                if (companyUUID === this.addBusinessCommand) {
                    this.openCreateCompanyDialog();
                    return;
                }
                const index = this.companyList.findIndex(item => item.innerUUID === companyUUID);
                if (index === -1 || index === getSelectedCompanyIndex()) {
                    return;
                }
                let currentSelection = applyCompanySelectionByIndex(index);
                if (currentSelection == null) {
                    return;
                }
                window.location.reload();
            },
            openCreateCompanyDialog() {
                const loginInformation = JSON.parse(localStorage.getItem('loginInformation')).objectData;
                if (!canCreateNewCompany(loginInformation)) {
                    openFastSpringPage(getCurrentPlanName(loginInformation), 'Premium');
                    return;
                }
                this.newCompanyName = '';
                this.createCompanyDialog = true;
                this.$nextTick(() => {
                    this.$refs.companyNameInput.focus();
                });
            },
            createCompany() {
                if (this.createCompanyLoading) {
                    return;
                }
                const companyName = this.newCompanyName.trim();
                if (companyName === '') {
                    this.$message.error(this.$t('menu.businessNameRequired'));
                    return;
                }

                const companyUUID = uuid(null, 37);
                this.createCompanyLoading = true;
                this.$axios.post('web_create_company', {
                    params: {
                        companyName: companyName,
                        companyUUID: companyUUID,
                        settingUUID: uuid(null, 37)
                    }
                }).then(response => {
                    if (response.data.errorCode !== 0) {
                        this.createCompanyLoading = false;
                        return null;
                    }
                    return this.$axios.post('query_setting_and_company', {params: {}});
                }).then(response => {
                    if (response == null) {
                        return;
                    }
                    if (response.data.errorCode !== 0) {
                        this.createCompanyLoading = false;
                        return;
                    }
                    syncCompanySelection(response.data);
                    applyCompanySelectionByUUID(companyUUID);
                    this.$message.success(this.$t('menu.createBusinessSuccess'));
                    window.location.reload();
                }).catch(() => {
                    this.createCompanyLoading = false;
                });
            },
            getCompanyLogoUrl(companyLogo) {
                if (companyLogo.remoteKey != null && companyLogo.remoteKey !== "") {
                    return getDownloadV2Url(this.$store.state.requestURL, companyLogo.remoteKey);
                }
                return this.$store.state.requestURL + "file/download?fileName=" + companyLogo.imagePath + "&email=" + JSON.parse(localStorage.getItem("loginInformation")).objectData.email;
            },
            getCompanyLogoUrlByCompany(company) {
                if (company == null) {
                    return "";
                }
                let companyLogo = this.companyLogoMap[company.innerUUID];
                if (companyLogo == null) {
                    return "";
                }
                if (companyLogo.syncStatus === 1) {
                    return "";
                }
                if ((companyLogo.remoteKey == null || companyLogo.remoteKey === "") && (companyLogo.imagePath == null || companyLogo.imagePath === "")) {
                    return "";
                }
                return this.getCompanyLogoUrl(companyLogo);
            },
            markCompanyLogoFailed(company) {
                if (company == null) {
                    return;
                }
                this.$set(this.failedLogoCompanyUUIDMap, company.innerUUID, true);
            },
            markCompanyLogoLoaded(company) {
                if (company == null) {
                    return;
                }
                this.$set(this.loadedLogoCompanyUUIDMap, company.innerUUID, true);
            },
            isCompanyLogoFailed(company) {
                if (company == null) {
                    return false;
                }
                return this.failedLogoCompanyUUIDMap[company.innerUUID] === true;
            },
            isCompanyLogoLoaded(company) {
                if (company == null) {
                    return false;
                }
                return this.loadedLogoCompanyUUIDMap[company.innerUUID] === true;
            },
            getCompanyInitial(company) {
                if (company == null || company.companyName == null || company.companyName === "") {
                    return "";
                }
                return company.companyName.substring(0, 1).toUpperCase();
            }
        }, mounted() {
            let loginInformation = JSON.parse(localStorage.getItem("loginInformation"));
            if (null != loginInformation) {

                this.loginEmail = loginInformation.objectData.email;
            }

            this.loadCompanyListFromStorage();
            this.loadCompanyListIfNeeded();
        }
    }
</script>

<style scoped>
    .sidebar {
        display: flex;
        flex-direction: column;
        flex: 0 0 300px;
        width: 300px;
        min-width: 300px;
        box-sizing: border-box;
        padding: 24px 18px 18px;
        color: rgba(255, 255, 255, 0.78);
        background: linear-gradient(180deg, #13264d 0%, #101d3a 100%);
        border-radius: 0 20px 20px 0;
        box-shadow: 8px 0 32px rgba(17, 37, 76, 0.14);
        height: 100vh;
        overflow-y: auto;
        font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Microsoft YaHei", sans-serif;
    }

    .sidebar-menu {
        flex: 1;
        width: 100%;
        padding: 0;
        border: none;
        background: transparent !important;
    }

    .menuValue {
        flex: 1;
        margin-left: 0;
        font-size: 15px;
        font-weight: 600;
    }

    .sidebar-menu-icon {
        width: 22px;
        flex: 0 0 22px;
        margin-right: 14px;
        color: rgba(255, 255, 255, 0.68);
        font-size: 22px;
        text-align: center;
    }

    .feedback-reply-badge {
        flex: 0 0 auto;
        padding: 2px 7px;
        border-radius: 9px;
        color: #ffffff;
        background: #F56C6C;
        font-size: 11px;
        font-weight: 700;
        line-height: 16px;
        white-space: nowrap;
    }

    .accountMenuItem {
        height: auto !important;
        line-height: normal !important;
        padding: 0 !important;
        margin: 0 0 16px !important;
        background: transparent !important;
    }

    .accountMenuItem:hover,
    .accountMenuItem:focus,
    .accountMenuItem.is-active {
        background-color: transparent !important;
    }

    .sidebar-user {
        width: 100%;
        display: flex;
        align-items: center;
        gap: 14px;
        padding: 14px 6px 24px;
        box-sizing: border-box;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        cursor: pointer;
    }

    .sidebar-avatar {
        width: 48px;
        height: 48px;
        flex: 0 0 48px;
        display: grid;
        place-items: center;
        overflow: hidden;
        border-radius: 12px;
        color: #ffffff;
        background: linear-gradient(135deg, #6b7cff, #4b45e8);
        font-size: 24px;
        font-weight: 700;
        line-height: 1;
        box-shadow: 0 12px 28px rgba(75, 69, 232, 0.28);
    }

    .sidebar-avatar-image {
        width: 100%;
        height: 100%;
        display: none;
        object-fit: contain;
        background: #ffffff;
    }

    .sidebar-avatar-image.is-visible {
        display: block;
    }

    .sidebar-user-content {
        flex: 1;
        min-width: 0;
    }

    .sidebar-user-name {
        overflow: hidden;
        color: #ffffff;
        font-size: 16px;
        font-weight: 700;
        line-height: 22px;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .sidebar-user-email {
        margin-top: 2px;
        overflow: hidden;
        color: rgba(255, 255, 255, 0.68);
        font-size: 13px;
        font-weight: 500;
        line-height: 18px;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .companyDropdownWrapper {
        flex: 0 0 auto;
    }

    .companyDropdown {
        display: block;
    }

    .companyArrowButton {
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 0;
        background: transparent;
        color: #ffffff;
        cursor: pointer;
        padding: 0;
    }

    .companyArrow {
        color: rgba(255, 255, 255, 0.72);
        font-size: 16px;
    }

    .sidebar-menu >>> .el-menu-item:not(.accountMenuItem),
    .sidebar-menu >>> .el-submenu__title {
        height: 50px !important;
        line-height: 50px !important;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        margin: 0 0 6px;
        padding: 0 14px !important;
        border-radius: 11px;
        color: rgba(255, 255, 255, 0.78) !important;
        background: transparent !important;
        font-size: 15px;
        font-weight: 600;
        transition: color 180ms ease, background 180ms ease, box-shadow 180ms ease, transform 180ms ease;
    }

    .sidebar-menu >>> .el-menu-item:not(.accountMenuItem):hover,
    .sidebar-menu >>> .el-submenu__title:hover {
        color: #ffffff !important;
        background: rgba(255, 255, 255, 0.07) !important;
    }

    .sidebar-menu >>> .el-menu-item.is-active:not(.accountMenuItem):not(.sidebar-submenu-child) {
        color: #ffffff !important;
        background: linear-gradient(90deg, #2676f3 0%, #315edb 100%) !important;
        box-shadow: 0 8px 22px rgba(36, 105, 230, 0.28);
    }

    .sidebar-menu >>> .el-menu-item.is-active:not(.accountMenuItem):not(.sidebar-submenu-child) .sidebar-menu-icon,
    .sidebar-menu >>> .el-menu-item:not(.accountMenuItem):hover .sidebar-menu-icon,
    .sidebar-menu >>> .el-submenu__title:hover .sidebar-menu-icon,
    .sidebar-menu >>> .el-submenu.is-opened > .el-submenu__title .sidebar-menu-icon {
        color: #ffffff;
    }

    .sidebar-menu >>> .el-submenu.is-opened > .el-submenu__title {
        color: #ffffff !important;
    }

    .sidebar-menu >>> .el-submenu__icon-arrow {
        right: 14px;
        color: rgba(255, 255, 255, 0.72);
        font-weight: 700;
    }

    .subMenuValue {
        margin: 4px 0 8px 38px;
        padding-left: 18px;
        border-left: 1px solid rgba(255, 255, 255, 0.1);
        font-size: 14px;
    }

    .subMenuValue >>> .el-menu-item-group__title {
        display: none;
        padding: 0;
    }

    .subMenuValue >>> .el-menu-item.sidebar-submenu-child {
        min-height: 42px !important;
        height: 42px !important;
        line-height: 42px !important;
        display: flex;
        align-items: center;
        margin: 3px 0;
        padding: 0 12px !important;
        border-radius: 9px;
        color: rgba(255, 255, 255, 0.66) !important;
        background: transparent !important;
        box-shadow: none;
        font-size: 14px;
        font-weight: 500;
    }

    .subMenuValue >>> .el-menu-item.sidebar-submenu-child:hover {
        color: #ffffff !important;
        background: rgba(255, 255, 255, 0.06) !important;
    }

    .subMenuValue >>> .el-menu-item.sidebar-submenu-child.is-active {
        color: #9fc4ff !important;
        background: rgba(54, 119, 246, 0.16) !important;
        box-shadow: none;
    }

    .sidebar-submenu-icon {
        width: 18px;
        flex: 0 0 18px;
        margin-right: 10px;
        color: currentColor;
        font-size: 18px;
        text-align: center;
    }

    .sidebar-lang-switcher {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 20px;
        padding: 0 24px;
        box-sizing: border-box;
    }

    .sidebar-lang-trigger {
        width: 100%;
        height: 64px;
        flex: 0 0 auto;
        display: flex;
        align-items: center;
        gap: 14px;
        box-sizing: border-box;
        padding: 0 24px;
        border: 0;
        border-radius: 11px;
        color: #ffffff;
        background: rgba(54, 98, 190, 0.38);
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.06);
        cursor: pointer;
        font-size: 15px;
        font-weight: 700;
        text-align: left;
        transition: background 180ms ease, transform 180ms ease, box-shadow 180ms ease;
        outline: none;
    }

    .sidebar-lang-trigger:hover {
        background: rgba(54, 119, 246, 0.46);
        box-shadow: 0 10px 24px rgba(12, 30, 67, 0.16);
    }

    .sidebar-lang-trigger:active {
        transform: scale(0.985);
    }

    .sidebar-lang-trigger > i:first-child {
        font-size: 24px;
    }

    .sidebar-lang-current {
        flex: 1 1 auto;
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .sidebar-lang-caret {
        font-size: 14px;
        margin-left: auto;
    }

    .sidebar-lang-menu .el-dropdown-menu__item.is-active {
        color: #0d6dfd;
        font-weight: 700;
    }

    .signOutButton {
        width: 100%;
        height: 64px;
        flex: 0 0 auto;
        display: flex;
        align-items: center;
        gap: 14px;
        box-sizing: border-box;
        margin-top: 20px;
        padding: 0 24px;
        border: 0;
        border-radius: 11px;
        color: #ffffff;
        background: rgba(54, 98, 190, 0.38);
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.06);
        cursor: pointer;
        font-size: 15px;
        font-weight: 700;
        text-align: left;
        transition: background 180ms ease, transform 180ms ease, box-shadow 180ms ease;
    }

    .signOutButton:hover {
        background: rgba(54, 119, 246, 0.46);
        box-shadow: 0 10px 24px rgba(12, 30, 67, 0.16);
    }

    .signOutButton:active {
        transform: scale(0.985);
    }

    .signOutButton i {
        font-size: 24px;
    }
</style>

<style>
    .company-dropdown-popper,
    .companyDropdownMenu {
        min-width: 320px !important;
        max-width: 360px !important;
        padding: 10px 0;
    }

    .company-dropdown-popper .companyDropdownItem {
        height: auto;
        padding: 12px 16px;
        line-height: normal;
        box-sizing: border-box;
    }

    .company-dropdown-popper .companyDropdownItem:not(:last-child) {
        border-bottom: 1px solid #E6E8EF;
    }

    .company-dropdown-popper .companyOption {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 14px;
        width: 100%;
        min-height: 58px;
        overflow: hidden;
    }

    .company-dropdown-popper .companyOptionLogo {
        max-width: 100px !important;
        height: 50px !important;
        min-height: 50px !important;
        max-height: 50px !important;
        flex: 0 0 auto !important;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
    }

    .company-dropdown-popper .companyOptionLogo img,
    .company-dropdown-popper .companyOptionLogoImage {
        max-width: 100px !important;
        max-height: 50px !important;
        width: auto !important;
        height: auto !important;
        object-fit: contain !important;
        display: none;
        background: #ffffff;
    }

    .company-dropdown-popper .companyOptionLogoImage.is-visible {
        display: block;
    }

    .company-dropdown-popper .companyOptionName {
        flex: 1;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 16px;
        color: #303133;
    }

    .company-dropdown-popper .addBusinessItem {
        padding: 10px 16px;
    }

    .company-dropdown-popper .addBusinessOption {
        min-height: 44px;
        display: flex;
        align-items: center;
        gap: 10px;
        color: #1769e0;
        font-size: 15px;
        font-weight: 700;
    }

    .company-dropdown-popper .addBusinessOption > i {
        width: 28px;
        height: 28px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border-radius: 8px;
        color: #ffffff;
        background: #2676f3;
        font-weight: 700;
    }

    .create-company-dialog {
        border-radius: 12px;
    }

    .create-company-dialog .el-dialog__header {
        padding: 24px 26px 12px;
    }

    .create-company-dialog .el-dialog__body {
        padding: 18px 26px 8px;
    }

    .create-company-dialog .el-dialog__footer {
        padding: 16px 26px 24px;
    }
</style>
